import { useState } from "react";

import { useQuery } from "@apollo/client";

import { FETCH_PUBLIC_RECIPES_BY_CATEGORY } from "../../app/graphql/queries";
import { setHomeConfigAndCategoryToRecipeId } from "../../app/homepage/homepage.slice";
import { CategoryRecipeID } from "../../app/homepage/homepage.types";
import { useAppDispatch } from "../../app/store/hooks";
import { Category, HomeScreen, RecipeCategoryMap } from "../../components/newHomePage/utils/homepageJson.types";
import { jsonSanitizer } from "../../components/newHomePage/utils/newHomePageUtils";
import { getCategoryIds } from "../../components/newHomePage/utils/useHomePageJson";
import useGetS3Data from "../../hooks/useGetS3Data";

const usePublicHomepage = () => {
  const dispatch = useAppDispatch();
  const [defaultHomeConfig, setDefaultHomeConfig] = useState<HomeScreen | null>(null);
  const [categoryIds, setCategoryIds] = useState<string[]>([]);
  const { data: homepageData, loading: loadingS3Data } = useGetS3Data<HomeScreen>({
    onCompleted: (data) => {
      if (data) {
        setCategoryIds(getCategoryIds(data));
      }
    },
  });

  const { loading: fetchingCategoryToRecipeId } = useQuery(FETCH_PUBLIC_RECIPES_BY_CATEGORY, {
    skip: categoryIds.length === 0,
    variables: { categoryIds },
    onCompleted: (data) => {
      const categoryToRecipeId: CategoryRecipeID = {};

      data.recipe_categories.forEach((category: Category) => {
        const categoryId = category.id;
        const categoryName = category.Recipe_Categories_Map[0]?.recipe_category.name || "";
      
        if (!categoryToRecipeId[categoryId]) {
          categoryToRecipeId[categoryId] = {
            categoryName,
            recipeIds: [],
          };
        }
      
        category.Recipe_Categories_Map.forEach((map: RecipeCategoryMap) => {
          categoryToRecipeId[categoryId].recipeIds.push(map.Recipe_ID);
        });
      });
      

      const sanitizedData = jsonSanitizer(homepageData as HomeScreen, categoryToRecipeId);
      setDefaultHomeConfig(sanitizedData);
      dispatch(
        setHomeConfigAndCategoryToRecipeId({
          mobile_version: 0,
          mobile_config: sanitizedData,
          categoryToRecipeId,
        }),
      );
    },
  });

  return { defaultHomeConfig, loading: loadingS3Data || fetchingCategoryToRecipeId };
};

export default usePublicHomepage;